import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { firebaseStateReducer } from 'react-redux-firebase'
import { LOADING_START, LOADING_STOP } from './actionTypes';

function loading(state={isLoading: true, message: 'โหลดข้อมูล...'}, action) {
    switch(action.type) {
        case LOADING_START:
            return Object.assign({}, {isLoading: true, message: action.message})
        case LOADING_STOP:
            return Object.assign({}, {isLoading: false})
        default:
            return state
    }
}
const reducer = combineReducers({
    //auth: authReducer,
    loading: loading,
    router: routerReducer,
    firebase: firebaseStateReducer,
})

export default reducer


// WEBPACK FOOTER //
// ./src/reducer.js